import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

import { ds } from '@/components/lib/design.system';
import { common, designSystem } from '@/styles/styles';

import { SizedBox } from './SizedBox';
import { Text, TextProps } from './TextComponent';

const styles = StyleSheet.create({
    badge: {
        borderRadius: 12,
        height: 24,
        paddingHorizontal: 8,
    },
    normal: {
        backgroundColor: ds.colorValue.background.brand.strong,
    },
    error: {
        backgroundColor: ds.colorValue.background.danger.strong,
    },
    info: {
        backgroundColor: designSystem.colors.neutral300,
    },
});

export const Badge = ({
    label,
    style,
    type = 'normal',
    leftIcon,
    textProps,
    ...props
}: ViewProps & {
    leftIcon?: React.ReactNode;
    textProps?: TextProps;
    label: string;
    type?: 'normal' | 'error' | 'info';
}) => {
    return (
        <View
            style={[
                common.row,
                common.alignCenter,
                common.justifyCenter,
                common.borderCurve,
                styles.badge,
                styles[type],
                style,
            ]}
            {...props}
        >
            {leftIcon ? (
                <>
                    {leftIcon}
                    <SizedBox value={5} />
                </>
            ) : null}
            <Text variant="labelMedium" {...textProps} testID="badgeLabel">
                {label}
            </Text>
        </View>
    );
};
